import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import connect from '../../utils/connect';

import { Row, Col, FormGroup, FormGroupLabel } from '@app/ui';
import classNames from '@app/ui/sports-components/utils/classNames';

import { Context } from '../contexts/OnboardingContext';
import { PlacementContext } from '../contexts/PlacementContext';

type PlacementNameProps = {
    selectedPlacementName: string;
};

const PlacementName = ({ selectedPlacementName }: PlacementNameProps) => {
    const { t } = useTranslation('settings');
    const { hasStandardPlacements, currentSelectedPlacement, structureLocked } =
        useContext(Context);
    const { displayName, setDisplayName, isEditingName, setIsEditingName } =
        useContext(PlacementContext);
    const { reloName } = currentSelectedPlacement;

    const updateDisplayName = e => {
        const value = e.target.value;
        setDisplayName(value);
    };

    const displayNameComponent = () => {
        if (isEditingName) {
            return (
                <input
                    className={
                        'gds-form-group__text-input gds-form-group__text-input--sm'
                    }
                    type="text"
                    placeholder={t(
                        'clientConfiguration.onboarding.enterDisplayName',
                    )}
                    data-gds-search-input=""
                    id="enterDispName"
                    value={displayName}
                    onChange={updateDisplayName}
                />
            );
        } else {
            return (
                <>
                    {selectedPlacementName}
                    <i
                        className={classNames(
                            'fa fa-fw fa-pencil gds-text--body-sm -color-tx-dk-5 -m-t-1 -m-b-2',
                            {
                                '-cursor--pointer': !structureLocked,
                                '-cursor--not-allowed': structureLocked,
                            },
                        )}
                        style={structureLocked ? { opacity: 0.35 } : undefined}
                        onClick={
                            structureLocked
                                ? undefined
                                : () => setIsEditingName(!isEditingName)
                        }
                        role="button"
                        aria-disabled={structureLocked}
                    />
                </>
            );
        }
    };

    return (
        <>
            {!hasStandardPlacements && <span>{selectedPlacementName}</span>}
            {hasStandardPlacements && (
                <Row gutter={16} className="-p-h-2">
                    <Col md={12} className="-m-b-2">
                        <FormGroup layout="vertical">
                            <FormGroupLabel
                                text={t(
                                    'clientConfiguration.onboarding.placementType',
                                )}
                            />
                            <Row gutter={16}>{reloName}</Row>
                        </FormGroup>
                    </Col>
                    <Col md={12} className="-m-b-2">
                        <FormGroup layout="vertical">
                            <FormGroupLabel
                                text={t(
                                    'clientConfiguration.onboarding.displayName',
                                )}
                            />
                            <Row gutter={16}>{displayNameComponent()}</Row>
                        </FormGroup>
                    </Col>
                </Row>
            )}
        </>
    );
};

export default connect(['user', 'client'])(PlacementName);
